import React from "react";

import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useApi } from "../../hooks/useApi";
import { QuickDiscoveryData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import styles from "./QuickDiscovery.module.css";

export default function QuickDiscovery() {
  const navigate = useNavigate();
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_QUICK_DISCOVERY
  );
  const apiData = response?.quickDiscovery ?? QuickDiscoveryData;
  return (
    <section className={styles.container}>
      <div className={styles.quick}>
        <h3>
          Quick <span>Discovery</span>
        </h3>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((item) => (
              <article className={styles.card} key={item.id}>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_ASSETS_BASE_URL || "https://api.imparc.site/assets/uploads/"}` + item.image}
                    alt="Find an Expert Mentor"
                  />
                </figure>
                <h4>{item.title}</h4>
                <p>{item.short_desc}</p>
                <button onClick={() => navigate(item.link)}>
                  {item.button_name}
                </button>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
